
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.1","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M10.152 0a3.992 3.992 0 01.386.125 1.956 1.956 0 011.3 1.8c.006.224 0 .449 0 .7h3.54a1.639 1.639 0 011.726 1.726v1.19a.656.656 0 01-.7.692H.704a.653.653 0 01-.7-.692 11.705 11.705 0 01.037-1.552A1.578 1.578 0 011.649 2.63c1.122-.006 2.243 0 3.371 0h.249v-.58A1.965 1.965 0 016.883.043a.242.242 0 00.069-.037C8.021 0 9.086 0 10.152 0zM6.581 2.611h3.945c0-.231.006-.449 0-.667a.645.645 0 00-.636-.629c-.891-.006-1.782-.006-2.667 0a.645.645 0 00-.636.6c-.018.229-.006.459-.006.696zM8.55 7.546h7.148c.318 0 .361.056.349.374l-.224 4.686c-.106 2.2-.2 4.393-.324 6.593a1.92 1.92 0 01-1.926 1.795c-.81.012-1.614 0-2.424 0h-7.54a1.932 1.932 0 01-1.982-1.614 11.118 11.118 0 01-.087-1.29l-.262-5.571-.224-4.63c-.012-.293.037-.355.33-.355 2.386.012 4.779.012 7.166.012zm-3.945 5.908v1.745c0 .841-.006 1.683 0 2.524a.658.658 0 001.3.131 1.268 1.268 0 00.012-.268V9.323c0-.062.006-.125 0-.187a.643.643 0 00-.418-.561.655.655 0 00-.891.654q-.006 2.113-.003 4.225zm4.605 0v-4.2a.677.677 0 00-.411-.673.661.661 0 00-.9.661v8.425a.659.659 0 101.315.012zm3.284.019V9.248a.677.677 0 00-.411-.673.661.661 0 00-.9.661v8.4a.686.686 0 00.218.555.607.607 0 00.7.118.65.65 0 00.393-.642z"}})])
          )
        }
      }
    